import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import workoutImage from "../img/session_bg.png";
import SideNav from "components/SideNav";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/firebase";
import Shimmer from "react-shimmer-effect";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function Sessions() {
  useEffect(() => {}, []);

  const [planList, setPlanList] = useState(<></>);
  const [isLoading, setIsLoading] = useState(true);

  const getData = async (isAdmin, permissions) => {
    var q;

    const elements = [<></>];

    if (isAdmin) {
      q = query(collection(db, "workouts"));
    } else {
      try {
        q = query(
          collection(db, "workouts"),
          where("permission_groups", "array-contains-any", permissions)
        );
      } catch (error) {
        elements.push(
          <h3 style={{ color: "#000", textAlign: "center" }}>
            {"Keine Trainingseinheiten gefunden."}
          </h3>
        );

        elements.push(
          <a href="createsession">
            <div className="flex-row">
              <i style={{ color: "#7a3260" }} className="fa-solid fa-plus">
                <FontAwesomeIcon
                  icon={icon({ name: "plus", style: "solid" })}
                />
              </i>
              <div className="right">
                <h3 style={{ margin: 0 }}>Trainingseinheit hinzufügen</h3>
              </div>
            </div>
          </a>
        );

        setPlanList(elements);
        setIsLoading(false);

        console.log("error:::");
        console.log(error);
      }
    }

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      var refString = "editsession?sessionid=" + doc.id;

      if (doc?.data()?.isActive == false) {
      } else {
        var imgUrl = workoutImage;

        elements.push(
          <a
            className="flex-row"
            href={refString}
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(33,37,43,0.90), rgba(33,37,43,0.90)), url(${imgUrl})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div>
              <h3 style={{ color: "#fff" }}>{doc.data().name_de}</h3>
            </div>
          </a>
        );
      }
    });

    elements.push(
      <a href="createsession">
        <div className="flex-row">
          <i style={{ color: "#7a3260" }} className="fa-solid fa-plus">
            <FontAwesomeIcon icon={icon({ name: "plus", style: "solid" })} />
          </i>
          <div className="right">
            <h3 style={{ margin: 0 }}>Trainingseinheit hinzufügen</h3>
          </div>
        </div>
      </a>
    );

    setPlanList(elements);
    setIsLoading(false);
  };

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      getData(doc.data().isAdmin, doc.data().permission_groups);
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const selPage = "sessions";

  const RenderLoading = () => (
    <>
      <a
        className="flex-row"
        style={{
          backgroundColor: "fff", //"#fff",
        }}
        // style={{
        //   backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${background_image})`,
        //   backgroundRepeat: "no-repeat",
        //   backgroundSize: "cover",
        // }}
      >
        <a
          style={{
            width: "80%",
            marginLeft: 0,
            padding: 0,
            gap: 0,
            gridTemplateColumns: "none",
            backgroundColor: "#fff",
          }}
          className="grid"
        >
          <Shimmer>
            <div
              style={{
                width: "100%",
                height: 20,
                backgroundColor: "#eee",
                borderRadius: 999,
                marginBottom: 25,
              }}
              className="grid"
            ></div>
          </Shimmer>
        </a>
      </a>
    </>
  );

  const Content = () => (
    <section className="home-section">
      <div className="text">
        Trainingseinheiten
        <a
          href="createsession"
          style={{
            color: "white",
            marginTop: 50,
            marginLeft: 15,
          }}
          className="fa-solid fa-plus"
        >
          <FontAwesomeIcon
            style={{
              backgroundColor: "#7a3260",
              padding: 5,
              borderRadius: 999,
              width: "15px",
              height: "15px",
            }}
            icon={icon({ name: "plus", style: "solid" })}
          />
        </a>
      </div>

      {/* sessions */}
      <section style={{ paddingTop: 50 }} className="my-plans" id="plans">
        <div className="container">
          <h2 style={{ marginBottom: "40px" }}>Aktive Trainingseinheiten</h2>
          <div className="grid-sessions plan-list" id="plan-list">
            {isLoading ? (
              <>
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
              </>
            ) : (
              <>{planList}</>
            )}
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>
      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
